// exclude-from-index
import React, { Component } from 'react';
import Grid from '../../../../Utility/Grid';
import Desktop from './Desktop';
import { propTypes } from './FiltersContainer.shapes';
import { defaultProps } from './FiltersContainer.seed';
import { OPTION, LABEL, START_DATE, END_DATE } from './FiltersContainer.constants';

export { OPTION, LABEL, START_DATE, END_DATE };

export default class FiltersContainer extends Component {
  static propTypes = propTypes;

  static defaultProps = defaultProps;

  render() {
    return (
      <Grid.ScreenClassRender
        render={screenClass => {
          const mobile = ['sm', 'xs'].indexOf(screenClass) !== -1;
          return <Desktop {...this.props} show={!mobile} />;
        }}
      />
    );
  }
}
